<template lang="pug">
  div
    .sheets.white(v-if="sheets.length || !noResultsAlt.length || loading" :class="{ 'all-sheets': showAll, 'elevation-2': elevate && !loading }")
      rc-table(
        ref="sheetTable"
        @tableSearchAction="goToClient"
        @sendEmit="emit"
        @recall="data => $emit('recall', data)"
        :totalItems="typeof metadata === 'undefined' ? 0 : metadata.count"
        :items="sheets"
        :headers="showAll ? headers : headers.filter(x => x.type !== 'selection')"
        :loading="loading"
        :displayFilters="showAll"
        :displaySortable="showAll"
        :maxItems="5000"
        :showPagination="(showAll || paginate)"
        :deleteAction="false"
        :clickToVisit="clickToVisit && !$store.state.app.user.touristicProvider"
        searchField="raison_sociale"
      )
    v-layout.justify-center.py-5.mb-5(v-else)
      .subheading.font-italic.grey--text.text--darken-2 {{ noResultsAlt }}
</template>

<script>
import RcTable from '@/components/RcTable/RcTable.vue';
import axios from 'axios';

export default {
  components: {
    RcTable,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    sheets: {
      type: Array,
      default: () => [],
    },
    metadata: {
      type: Object,
      default: () => {},
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    paginate: {
      type: Boolean,
      default: false,
    },
    elevate: {
      type: Boolean,
      default: false,
    },
    customActions: {
      type: Array,
      default: () => [],
    },
    noResultsAlt: {
      type: String,
      default: '',
    },
    clickToVisit: {
      type: Boolean,
      defaut: true,
    },
    orphanHeaders: {
      type: Array,
      default: () => [
        {
          label: 'Compte',
          // sortable: true,
          column: 'owner_for_client_name',
          type: 'route',
          // filters: {
          //   type: 'text',
          //   operands: ['ilike'],
          //   column: 'client_name',
          // },
          to: {
            name: 'client_sheets',
            params: {
              clientId: 'owner_for_client_id',
            },
          },
          // filters: {
          //   type: 'text',
          //   operands: ['ilike'],
          //   field: 'p.name'
          // },
        },
        {
          label: 'Types de fiches',
          type: 'not exists',
          // sortable: false,
          column: 'owner_for_client_id',
          center: true,
          filters: {
            values: [
              { label: 'Toutes les fiches', value: 'all' },
              { label: 'Fiches associées à un compte', value: 'noOrphans' },
              { label: 'Fiches sans compte', value: 'onlyOrphans' },
            ],
            default: { label: 'Toutes les fiches', value: 'all' },
            operands: [],
            type: 'select',
            customHandler: 'toggleSendOrphans',
          },
        },
      ],
    },
  },
  data() {
    return {
      headers: [
        {
          label: 'ID TS',
          type: 'id',
          sortable: false,
          column: 'id',
          width: '0px',
        },
        {
          label: '',
          type: 'sheet_image',
          sortable: false,
          column: 'medias',
          padding: 'none',
          width: '100px',
        },
        {
          label: 'Raison sociale',
          // sortable: true,
          column: 'raison_sociale',
          filters: {
            entity: 'sheet',
            type: 'text',
            operands: ['ilike'],
          },
        },
        {
          label: "Type d'établissement",
          type: 'bordereau',
          // sortable: true,
          filters: {
            entity: 'sheet',
            type: 'autocomplete',
            operands: ['in'],
            field: 'bordereau',
          },
          column: 'bordereau',
        },
        {
          label: 'Commune',
          // sortable: true,
          column: 'commune',
          filters: {
            entity: 'sheet',
            type: 'text',
            operands: ['ilike'],
          },
        },
        ...(this.$store.state.app.user.touristicProvider ? [] : this.orphanHeaders),
        {
          label: 'Réf. SIT source',
          // sortable: true,
          column: 'source_identifier',
        },
        {
          label: 'Réf. TourismSystem',
          sortable: false,
          column: 'id',
        },
        {
          label: 'Actions',
          type: 'actions',
          align: 'center',
          center: true,
          buttons: [
            ...this.customActions,
          ],
        },
      ],
      addUserDialog: false,
    };
  },
  computed: {
    isDMO() {
      return !this.$store.state.app.user.touristicProvider
    },
  },
  methods: {
    emit(data) {
      this.$emit(data.emitName, data.value);
    },
    async getTypes() {
      const params = !!this.$refs.sheetTable ? { ...this.$refs.sheetTable.extraParams } : {};
      const response = await this.$store.dispatch('sheets/getTypes');
      const newHeaders = JSON.parse(JSON.stringify(this.headers))
      const pFilter = newHeaders.find(x => x.column === 'bordereau');
      pFilter.filters.values = this.$store.state.sheets.types;
      this.headers = newHeaders;
    },
    goToClient(data) {
      this.$router.push({ name: 'client_sheets', params: { clientId: data.owner_for_client_id } });
    },
  },
  mounted() {
    if (this.showAll) {
      this.getTypes();
    }
  },
};
</script>

<style lang="scss">
  .all-sheets {
    &.sheets {
      height: calc(100vh - 160px);
    }
  }
</style>